// export const skipInactivityUrls = ['/','/kiosk-code', '/settings', '/thanks'];
export const skipInactivityUrls = ['/', '/settings', '/thanks', '/home', '/kiosk-code'];